export default {
  "title": "Accademia",
  "subtitle": "Camp, programmi e workshop",
  "explore": "Esplorare",
  "myBookings": "Le mie prenotazioni",
  "search": "Cerca programmi",
  "category": "Categoria",
  "allCategories": "Tutti i gruppi",
  "date": "Data",
  "details": "Dettagli del programma",
  "book": "Prenota",
  "waiting": "Iscriviti alla lista di attesa",
  "participants": "Partecipanti e date",
  "summary": "Consenso e sintesi",
  "payment": "Pagamento",
  "confirm": "Conferma la prenotazione",
  "continue": "Continua",
  "back": "Indietro",
  "consent": "Accetto questi termini per ogni partecipante selezionato e confermo alla mia autorità di prenotare.",
  "total": "Totale",
  "net": "Rete di rete",
  "tax": "Imposta",
  "free": "Gratis",
  "member_account": "Carica il mio account socio",
  "cash": "Contanti ricevuti dal club",
  "card": "Paga con carta",
  "cancel": "Annulla prenotazione",
  "cancelReason": "Motivo di cancellazione",
  "confirmed": "Prenotazione confermata",
  "held": "Luogo in corso — la partecipazione non è confermata",
  "expired": "Tensione scaduta",
  "cancelled": "Annullato",
  "payment_attention": "Le esigenze di pagamento",
  "pending": "In attesa",
  "paid": "Pagato",
  "on_account": "Caricato in conto socio",
  "none": "Nessun pagamento richiesto",
  "refund_pending": "Rimborso in attesa",
  "refund_failed": "Rimborso fallito",
  "refunded": "Rimborsato",
  "terms": "Termini",
  "eligibility": "Ammissibilità",
  "prerequisite": "Prerequisito",
  "venue": "Vendite",
  "schedule": "Calendario",
  "price": "Prezzo per partecipante",
  "availability": "Luoghi disponibili",
  "noProgrammes": "Nessun programma corrisponde ai tuoi filtri.",
  "noBookings": "Non hai prenotazioni dell'Accademia.",
  "loading": "Caricamento dell'Accademia...",
  "retry": "Riprova",
  "error": "Incapace di completare questa azione.",
  "unavailable": "Il pagamento della carta non è disponibile fino a quando la configurazione del fornitore del club è completa.",
  "reference": "Riferimento prenotazione",
  "self": "Sé stesso",
  "dependant": "Dipendente",
  "accept": "Accetta l'offerta",
  "decline": "Decline / lasciare la lista di attesa",
  "offered": "Luogo offerto",
  "waitingStatus": "Aspettare",
  "accepted": "Accettato",
  "declined": "Declinato",
  "offering": "Offrendo",
  "configure": "Configurazione della prenotazione",
  "assisted": "Prenotazione assistita",
  "guardianReview": "Recensione dell'autorità Guardian",
  "guardian": "socio del Guardian",
  "payer": "Payer / attore di prenotazione",
  "approve": "Approvazione dell'autorità tutrice",
  "reason": "Motivo di valutazione",
  "save": "Pubblicare la politica dei soci",
  "description": "Descrizione",
  "image": "URL dell'immagine",
  "categoryLabel": "Categoria",
  "termsLabel": "Termini di consenso e di cancellazione",
  "visible": "Visibile ai soci",
  "selectedDays": "Consentire i giorni selezionati",
  "accountCharge": "Consentire la ricarica del conto socio",
  "cashEnabled": "Consentire club cash insediamento",
  "cardEnabled": "Consentire il checkout della scheda configurato",
  "refundEnabled": "Rimborsabile prima della scadenza di cancellazione",
  "cancellationHours": "Termine di cancellazione (ore prima dell'inizio)",
  "minAge": "Età minima (opzionale)",
  "maxAge": "Età massima (opzionale)",
  "taxCode": "Codice fiscale ID",
  "mapping": "Chiave di mappatura delle entrate",
  "bookingOpen": "Apertura prenotazione",
  "bookingClose": "Chiude la prenotazione",
  "history": "Storia della prenotazione",
  "refresh": "Aggiorna",
  "selectOffering": "Seleziona un'offerta",
  "allOrNothing": "I partecipanti prenotano e cancellano come gruppo. I giorni selezionati utilizzano il prezzo del programma pubblicato.",
  "startCheckout": "Aprire il checkout sicuro",
  "resume": "Riprendere il pagamento",
  "age_unknown": "Il club ha bisogno di una data di nascita per verificare l'ammissibilità.",
  "age_ineligible": "Questo partecipante è al di fuori dell'intervallo di età configurato.",
  "prerequisite_required": "Questo partecipante non ha soddisfatto il prerequisito.",
  "guardian_authority_required": "È richiesta l'autorità tutrice approvata.",
  "terms_changed": "I termini sono cambiati. Verificare il programma corrente prima di continuare.",
  "payer_authority_required": "Non sei autorizzato ad addebitare il pagamento.",
  "cancellation_deadline_passed": "La scadenza di cancellazione è passata.",
  "occurrence_history_locked": "Questa sessione è iniziata o ha prove di presenza.",
  "offering_full": "Il programma è completo. Iscriviti alla lista d'attesa.",
  "already_enrolled": "Un partecipante selezionato ha già un posto o una lista di attesa.",
  "offering_not_ready": "Questo programma non è più prenotabile.",
  "booking_closed": "La finestra di prenotazione è chiusa.",
  "member_account_required": "È richiesto un account socio attivo.",
  "currency_unconfigured": "Il club deve configurare la sua valuta.",
  "tax_code_required": "Il club deve configurare un codice fiscale attivo.",
  "payment_method_unavailable": "Questo metodo di pagamento non è disponibile.",
  "idempotency_conflict": "Questa richiesta è cambiata. Inizia una nuova prenotazione.",
  "forbidden": "Non hai il permesso per questa azione.",
  "credit_limit_exceeded": "Questo acquisto supera il limite di credito dell'account socio.",
  "consent_required": "Accetti i termini prima di confermare.",
  "places_available": "I posti sono disponibili; prenota direttamente.",
  "offer_expired": "Questa offerta è scaduta.",
  "events": {
    "enrolment_confirmed": "Conferma della prenotazione dell'Accademia",
    "enrolment_cancelled": "Prenotazione dell'Accademia cancellata",
    "waiting_joined": "Elenco di attesa dell'Accademia",
    "place_offered": "Luogo dell'Accademia offerto",
    "place_offer_expired": "L'offerta dell'Accademia è scaduta",
    "waiting_declined": "Elenco di attesa dell'Accademia di sinistra",
    "waiting_attention": "Academy lista di attesa ha bisogno di rivedere",
    "schedule_changed": "Calendario dell'Accademia cambiato",
    "attendance_recorded": "Partecipazione all'Accademia registrata",
    "attendance_corrected": "La frequenza dell'accademia corretta",
    "payment_attention": "Il pagamento dell'Accademia ha bisogno di attenzione",
    "refund_completed": "Rimborso dell'Accademia completato",
    "reminder": "Promemoria prenotazione Academy"
  },
  "cancelOffering": "Annullare l'offerta futura e recuperare i pagamenti",
  "nonMemberDependant": "Nome non socio dipendente",
  "dateOfBirth": "Data di nascita",
  "createDependant": "Creare dipendente rivisto",
  "upcoming": "Prossimo",
  "past": "Passato",
  "attention": "L'attenzione della finanza",
  "reconcile": "Stato del fornitore di riconcile",
  "cashRefund": "Confermare il rimborso in contanti pagato",
  "retryRefund": "Recuperare il rimborso fallito",
  "cash_refund_confirmation_required": "Confermare che il rimborso in contanti è stato pagato.",
  "refund_not_retryable": "Il fornitore non ha confermato un fallimento del rimborso terminale.",
  "accountCredited": "Credito applicato all'account",
  "staff_scope_required": "È richiesto il permesso di iscrizione dei dipendenti espliciti.",
  "nonMemberParticipant": "Dipendente non socio",
  "personSearch": "Trova socio o dipendente",
  "employee": "Dipendenti",
  "member": "Socio",
  "employeePayerReview": "Ente pubblico dipendente",
  "employeePayerGuidance": "I posti dei dipendenti a pagamento richiedono un'autorizzazione riesaminata dal pagatore selezionato. L'occupazione non garantisce mai l'accesso al conto.",
  "approvePayer": "Approvare l'autorità di pagamento esplicita",
  "bookingActorMember": "Attore di prenotazione / contatto socio",
  "payerMember": "Pagamenti autorizzati",
  "assistingStaff": "Personale di assistenza: l'operatore del club firmato verificato.",
  "clubStaffActor": "Club Staff attore (gruppi dipendenti)",
  "noPayerFreeStaff": "Nessun socio pagatore (gruppo libero dei dipendenti)",
  "selectedOccurrences": "Funzioni selezionate",
  "clubLocalWindows": "Finestre di prenotazione all'ora del club",
  "club_timezone_required": "Il club deve configurare un fuso orario IANA valido.",
  "invalid_local_time": "Questo club-tempo locale non è valido o cade in un gap salva-luce. Scegliere un'altra volta.",
  "ambiguous_local_time": "Questo club-tempo locale si verifica due volte quando gli orologi cambiano. Scegliere un tempo non ambiguo.",
  "invalid_booking_window": "Prenotare vicino deve essere dopo la prenotazione aperta.",
  "waitingManagement": "Liste di attesa e offerte",
  "sequence": "FIFO sequenza",
  "priority": "Priorità verificata",
  "offerDeadline": "Termine per l'offerta",
  "inspectWaiting": "Ispezione gruppo di attesa",
  "waitingDetail": "Attendere i dettagli del gruppo",
  "prepareOffer": "Recensione offerta posto",
  "acceptOnBehalf": "Accettare l'offerta per conto",
  "declineOnBehalf": "Decline / lasciare per conto",
  "overridePriority": "Salvare la priorità verificata override"
};
